import type { ButtonHTMLAttributes, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type ButtonVariant = "primary" | "secondary" | "ghost";

type ButtonProps = {
  readonly children: ReactNode;
  readonly variant?: ButtonVariant;
  readonly className?: string;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const baseClasses =
  "inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60";

const variantClasses: Record<ButtonVariant, string> = {
  primary: "bg-primary-500 text-white hover:bg-primary-600 shadow-sm",
  secondary: "bg-secondary-600 text-white hover:bg-secondary-700 shadow-sm",
  ghost: "bg-transparent text-gray-700 hover:bg-gray-100"
};

export const Button = ({ children, variant = "primary", className, type = "button", ...rest }: ButtonProps) => {
  const classes = twMerge(baseClasses, variantClasses[variant], className);

  return (
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
};

